import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateJobRequestModel, EditJobRequestModel, JobRequest } from '../../models/inModels/jobRequest';

@Injectable()
export class JobRequestService {
	private requestRoute = '/api/sales/requests';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/sales/requests/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<JobRequest> {
		return this.http.get(`${this.auth.apiUrl}/api/sales/requests/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobRequest)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateJobRequestModel): Promise<JobRequest> {
		return this.http.post(`${this.auth.apiUrl}/api/sales/requests/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobRequest)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditJobRequestModel): Promise<JobRequest> {
		return this.http.post(`${this.auth.apiUrl}/api/sales/requests/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobRequest)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.requestRoute}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

    connect(id: number,admitionId: number): Promise<any> {
        return this.http.get(`${this.auth.apiUrl}${this.requestRoute}/connect/${id}/${admitionId}`, { headers: this.auth.header })
            .toPromise()
            .then(response => response)
            .catch(error => this.logging.handleError(error));
    }

    disconnect(id: number,admitionId: number): Promise<any> {
        return this.http.get(`${this.auth.apiUrl}${this.requestRoute}/disconnect/${id}/${admitionId}`, { headers: this.auth.header })
            .toPromise()
            .then(response => response)
            .catch(error => this.logging.handleError(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/business/job-request.service.ts